'use client';
import {useEffect} from 'react';
import {suppressMobileRegisterInterest} from './mobile-register-interest-suppression';

// Renders nothing; mount it inside a page's JSX to hide the layout-level
// mobile register-interest entry points (sticky bar + burger-menu CTA) for as
// long as that page is on screen.
export function SuppressMobileRegisterInterest() {
  useEffect(() => suppressMobileRegisterInterest(), []);
  return null;
}

SuppressMobileRegisterInterest.displayName = 'SuppressMobileRegisterInterest';
